export default __webpack_public_path__ + "static/media/Token of Terror.dc25a2c7.jpg";